import { useTranslation } from 'react-i18next';
import { marked } from 'marked';
import xss from 'xss';
import {
    Banner,
    BannerDescription,
    BannerEyebrow,
    BannerImage,
    BannerImageContainer,
    BannerLinks,
    BannerText,
    BannerTextContainer,
    BannerTitle,
    BoundedContent,
    Button,
    Column,
    FluidImage,
    GridContainer,
    Link,
    Row,
} from '@vp/swan';
import { sanitiseLocale } from '../../../../i18n/config';
import { useTrackNavigationClicked } from '../../../../utils/analytics';
import { logomakerCtaPathByLocale } from '../../../../utils/urls';

const FeatureBannerAiQuality = () => {
    const { t, i18n } = useTranslation();
    const locale = sanitiseLocale(i18n.language);

    const ctaRef = useTrackNavigationClicked(
        'Design Services',
        'Feature Banner Ai Quality CTA',
        logomakerCtaPathByLocale(locale),
        'logoMaker',
    );

    return (
        <BoundedContent
            as="section"
            id="ai-quality"
            paddingBottom={{ xs: 4, md: 8 }}
            paddingX={{ xs: 0, sm: 3, md: 4, lg: 4, xl: 4 }}
        >
            <GridContainer>
                <Row style={{ justifyContent: 'center' }}>
                    <Column span={12} spanXl={10} spanLg={11} paddingX={{ xs: 0 }}>
                        <Banner backgroundColor="standard">
                            <BannerTextContainer>
                                <BannerText textAlign="left">
                                    <BannerEyebrow>
                                        {t(
                                            'Logomaker GenAi Landing Page > Feature Banner AI Quality > Eyebrow.value',
                                        )}
                                    </BannerEyebrow>
                                    <BannerTitle as="h2" fontSkin="title-section">
                                        {t(
                                            'Logomaker GenAi Landing Page > Feature Banner AI Quality > Title.value',
                                        )}
                                    </BannerTitle>
                                    <BannerDescription
                                        as="p"
                                        dangerouslySetInnerHTML={{
                                            __html: xss(
                                                marked.parse(
                                                    t(
                                                        'Logomaker GenAi Landing Page > Feature Banner AI Quality > Description.value',
                                                    ),
                                                ) as string,
                                            ),
                                        }}
                                    />
                                    <BannerLinks display={{ xs: 'none', sm: 'flex' }}>
                                        <Button
                                            skin="primary"
                                            render={(props) => (
                                                <Link
                                                    to={logomakerCtaPathByLocale(locale)}
                                                    className={props.className}
                                                    ref={ctaRef}
                                                >
                                                    {props.children}
                                                </Link>
                                            )}
                                        >
                                            {t(
                                                'Logomaker GenAi Landing Page > Feature Banner AI Quality > CTA Text.value',
                                            )}
                                        </Button>
                                    </BannerLinks>
                                </BannerText>
                            </BannerTextContainer>
                            <BannerImageContainer>
                                <BannerImage>
                                    <FluidImage
                                        src={t(
                                            'Logomaker GenAi Landing Page > Feature Banner AI Quality > Image.src',
                                        )}
                                        alt={t(
                                            'Logomaker GenAi Landing Page > Feature Banner AI Quality > Image > Alt Text.value',
                                        )}
                                    />
                                </BannerImage>
                            </BannerImageContainer>
                        </Banner>
                    </Column>
                </Row>
            </GridContainer>
        </BoundedContent>
    );
};

export default FeatureBannerAiQuality;
